module.exports = __webpack_public_path__ + "static/media/rouget-barbet.8ec2445c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/rouget-barbet.png
// module id = 333
// module chunks = 0